import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65" width="1em" height="1em">
    <circle cx={32.5} cy={32.5} r={32.5} fill="fj-icons-bg-color" />
    <path
      d="M35.97 26.875l-1.586 12.688h-3.768L29.03 26.875V15.97h6.94v10.904zM32.5 51.198a3.469 3.469 0 010-6.938 3.469 3.469 0 110 6.938z"
      fill="fj-icons-primary-color"
    />
  </svg>
);

const StatusWarning = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default StatusWarning;
